export default "__VITE_ASSET__BEcenoyS__"